import type { ReactNode } from 'react';

import styles from './StateBlock.module.css';

interface StateBlockProps {
  tone?: 'neutral' | 'error' | undefined;
  title: string;
  description?: string | undefined;
  action?: ReactNode | undefined;
  compact?: boolean | undefined;
}

/**
 * Единый блок для empty / error / unavailable состояний.
 * DoD MVP: каждый экран обязан иметь loading, empty, error и unavailable состояния.
 */
export function StateBlock({
  tone = 'neutral',
  title,
  description,
  action,
  compact = false,
}: StateBlockProps) {
  return (
    <div
      className={[styles.block, styles[tone], compact && styles.compact].filter(Boolean).join(' ')}
      role={tone === 'error' ? 'alert' : undefined}
    >
      <p className={styles.title}>{title}</p>
      {description ? <p className={styles.description}>{description}</p> : null}
      {action ? <div className={styles.action}>{action}</div> : null}
    </div>
  );
}

interface SkeletonProps {
  width?: string | undefined;
  height?: string | undefined;
  /**
   * Радиус — токен своей ступени лестницы (`var(--radius-card)` для блока
   * карточки и т. д.), литералы не передаются. По умолчанию `--radius-control`.
   */
  radius?: string | undefined;
  className?: string | undefined;
}

/** Плейсхолдер загрузки. Заменяет контент, а не накладывается поверх. */
export function Skeleton({ width = '100%', height = '1rem', radius, className }: SkeletonProps) {
  return (
    <span
      className={[styles.skeleton, className].filter(Boolean).join(' ')}
      style={{ width, height, borderRadius: radius ?? 'var(--radius-control)' }}
      aria-hidden="true"
    />
  );
}
